import { Grid } from '@material-ui/core';
import React from 'react';
import HelpCentreServiceCard from './HelpCentreServiceCard';

/**
 * @name HelpServices
 * @param {*} props - react props
 * @returns {JSX.Element} - Renders Help centre services component
 */
const HelpServices = props => {
    const getGridSize = index => {
        if (props?.services?.length === 5 && index > 2) {
            return 6;
        }
        return 4;
    };
    return (
        <Grid container spacing={3}>
            {props?.services?.map((service, index) => (
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={getGridSize(index)}
                    key={index}
                    style={{ display: 'flex' }}
                >
                    <HelpCentreServiceCard {...service} />
                </Grid>
            ))}
        </Grid>
    );
};

export default HelpServices;
